import MovieCard from "./MovieCard";

const MovieDescription = ({ reviewData }) => {
  const { title, id, poster, rating, description, isMini } = reviewData;

  return (
    <div className="movie-desc">
      <div className="movie-container">
        <h1 className="movie-desc-title">{title}</h1>

        <div
          className={`movie-details ${isMini ? "mini-review" : "full-review"}`}
        >
          <div className="movie-text">
            <h2 className="movie-ref-title">{isMini ? "Mini " : ""}Review</h2>

            {!isMini && (
              <div className="movie-poster-container">
                <MovieCard id={id} poster={poster} />
              </div>
            )}

            <p
              className="movie-desc-review"
              dangerouslySetInnerHTML={{ __html: description }}
            />

            <h2 className="movie-rating">
              Rating: <span className="movie-rating-value">{rating}</span>
            </h2>
          </div>

          {isMini && (
            <div className="movie-poster-container">
              <MovieCard id={id} poster={poster} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MovieDescription;
